export const defaultSettings = {
  themeMode: "light",
  themeDirection: "ltr",
  themeColorPresets: "red",
  themeLayout: "horizontal",
  themeStretch: false,
};
